import DOMPurify from 'dompurify';

/** HTML with scripts, event handlers and other active content removed. */
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(String(html ?? ''), { USE_PROFILES: { html: true } });
}

const ESCAPES = {
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
};

export function escapeHtml(text) {
  return String(text ?? '').replace(/[&<>"']/g, (c) => ESCAPES[c]);
}

/** The https address of the first iframe in an embed snippet, or null. */
export function embedIframeSrc(code) {
  const doc = new DOMParser().parseFromString(String(code ?? ''), 'text/html');
  const src = doc.querySelector('iframe')?.getAttribute('src') || '';
  try {
    const url = new URL(src);
    return url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}
